import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from "react-router-dom";

import { store } from 'react-notifications-component';

import api from '../../services/api';
import { login } from "../../services/auth";
import identifyErrorMenssage from '../../services/identifyErrorMenssage';

import InputV3 from '../../components/input/novo/input_v3';
import ModalTermos from '../../components/modal/modalTermos';
import ModalPoliticas from '../../components/modal/modalPoliticas';
import GoogleLoginButton from '../../components/social-google-button-form';

import Email from '../../assets/icons/icon-email-black.svg';
import SetaCinza from '../../assets/icons/icon-right-gray.svg';
import SetaBranca from '../../assets/icons/icon-right-white.svg';
import LogoBranca from '../../assets/logo-agroreceita-branco.svg';
import CreditCardDesktop from '../../assets/icons/icon-credit-card.svg';
import CreditCardMobile from '../../assets/icons/icon-credit-card-white.svg';

import * as S from './styles';
import { theme } from '../../styles/theme';
import { Auxiliar, BodyG, BodyP, H3, TaglineM, TaglineP, TaglinePSpan } from '../../styles/stylesTypography';

import maintainUtm from '../../services/maintainUtm/index'

export const GOOGLE_EMAIL = '@agroreceita_google_email';
export const GOOGLE_USER = '@agroreceita_google_user';
export const GOOGLE_USER_PROFILE = '@agroreceita_google_user_profile';

const NovoCadastro = ({ location, ...props }) => {
    const [width, setWidth] = useState(window.innerWidth);

    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');

    const [nomeErrorMessage, setNomeErrorMessage] = useState('');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [obs, setObs] = useState('');

    const [utmParams, setUtmParams] = useState({});

    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    const [showTermos, setShowTermos] = useState(false);
    const [showPolitica, setShowPolitica] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [width]);

    const clickPolitica = () => {
        setShowPolitica(true);
    };

    const clickTermos = () => {
        setShowTermos(true);
    };

    const handleNomeChange = (e) => {
        const newNome = e.target.value;
        const trimmedNome = newNome.replace(/\s+/g, ' ');

        setNome(trimmedNome);
        setNomeErrorMessage('');
    };

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;

        setObs('email')
        
        setEmailErrorMessage('');

        const trimmedEmail = newEmail.trim();
        
        setEmail(trimmedEmail)

        if (validateEmail(newEmail) === '') {
            setEmailErrorMessage('');
        }
    };

    //Função de entrar com Google 
    const handleGoogleSuccess = async (nameGoogle, email) => {
        setNome(nameGoogle);
        setEmail(email);
        setObs('google');

        const newObs = 'google'

        const nomeValidationError = validateNome(nameGoogle);
        const emailValidationError = validateEmail(email);

        setNomeErrorMessage(nomeValidationError);
        setEmailErrorMessage(emailValidationError);

        const emailValidationResult = await validaEmail(nameGoogle, email, newObs);

        if (!nomeValidationError && !emailValidationError && (!emailValidationResult || !emailValidationResult.error)) {
            const utmParams = getParams();

            if (width < 767) {
                history.push({
                    pathname: "/cadastro-email",
                    search: maintainUtm(),
                    state: { nome: nameGoogle, email, utmParams, obs: newObs, emailValidationForm: false}
                });
            } else {
                history.push({
                    pathname: "/cadastro-completo",
                    search: maintainUtm(),
                    state: { nome: nameGoogle, email, utmParams, obs: newObs }
                });
            }
        }
    };

    //Valida o nome 
    const validateNome = (nome) => {
        if (!nome || nome === undefined) {
            return true;
        }
        
        if (nome.length < 4) {
            store.addNotification({
                title: "Erro!",
                message: 'O nome deve ter pelo menos 4 caracteres.',
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            
            setNomeErrorMessage('O nome deve ter pelo menos 4 caracteres.');
            return 'O nome deve ter pelo menos 4 caracteres.';
        }
        return '';
    };

    //Valida o E-mail 
    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]+(\.[a-zA-Z]+)*$/;
    
        if (!regex.test(email)) {
            return "Insira um e-mail válido.";
        }
        return '';
    };

    //Obtem a utm através da url
    const getParams = () => {
        const utm_term = decodeURIComponent(new URLSearchParams(window.location.search).get('utm_term'));
        const utm_id = decodeURIComponent(new URLSearchParams(window.location.search).get('utm_id'));
        const utm_source = decodeURIComponent(new URLSearchParams(window.location.search).get('utm_source'));
        const utm_medium = decodeURIComponent(new URLSearchParams(window.location.search).get('utm_medium'));
        const utm_campaign = decodeURIComponent(new URLSearchParams(window.location.search).get('utm_campaign'));
        const button = decodeURIComponent(new URLSearchParams(window.location.search).get('button'));
        const _ga = decodeURIComponent(new URLSearchParams(window.location.search).get('_ga'));

        const payload = {
            utm_term: utm_term && utm_term !== 'null' ? utm_term : '',
            utm_id: utm_id && utm_id !== 'null' ? utm_id : 0,
            utm_source: utm_source && utm_source !== 'null' ? utm_source : 'orgânico',
            utm_medium: utm_medium && utm_medium !== 'null' ? utm_medium : 'orgânico',
            utm_campaign: utm_campaign && utm_campaign !== 'null' ? utm_campaign : 'orgânico',
            button: button && button !== 'null' ? button : '0',
            _ga: _ga && _ga !== 'null' ? _ga : '',
        };

        return payload;
    };

    //Verifica se o e-mail inserido já tem cadastro ou não
    const validaEmail = async (nome, email, obs) => {
        try {
            if (email && width > 767) {
                setLoading(true);

                const response = await api.post('/cadastro/validaEmail', { email: email });

                if (response) {
                    setEmailErrorMessage('');

                    const utmParams = getParams();

                    history.push({
                        pathname: "/cadastro-completo",
                        search: maintainUtm(),
                        state: { nome, email, utmParams, obs }
                    });
                }  

                return { success: true };
            }

            if ( width < 767) {
                 await api.post('/cadastro/validaEmail', { email: email });

                return { success: true };
            }
        } catch (error) {
            const apiErrorMessage = identifyErrorMenssage(error, 'Falha ao validar o e-mail informado.');

            if (obs === "google") {
                try {
                    setLoading(true);
                    setEmailErrorMessage('');
                
                    const headers = { 'apiKey': process.env.REACT_APP_API_KEY };
                
                    const payload = {
                        username: email,
                        password: null, 
                        loginSocial: 1,
                        type: 'google',
                    }; 
                
                    const response = await api.post(`/login`, payload, { headers });
                    
                    login(response.data.data);
        
                    const isLogged = localStorage.getItem('@logged');
                    const isOpen = localStorage.getItem('@open');
                
                    if ((isLogged === 'false' || !isLogged) && (isOpen === 'false' || !isOpen)) {
                        localStorage.setItem('@open', 'true');
                        
                        window.location = '/apresentacao';
                     } else {
                        window.location = '/'; 
                    }
                
                } catch (error) {

                } finally {
                    setLoading(false);
                }
            } else {
                setEmailErrorMessage(apiErrorMessage);

                store.addNotification({
                    title: "Erro!",
                    message: apiErrorMessage,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }

            return { error: apiErrorMessage };
        } finally {
            setLoading(false);
        }
    };

    //Função que executa a validação de e-mail, se nome e e-mail estiverem preenchidos
    const handleContinuarClick = async () => {
        const nomeValidationError = validateNome(nome);
        const emailValidationError = validateEmail(email);

        setNomeErrorMessage(nomeValidationError);
        setEmailErrorMessage(emailValidationError);

        if (!nomeValidationError && !emailValidationError) {
            setTimeout(() => validaEmail(nome, email, obs), 0);
        }
    };

    const handleCreatManual = async () => {
        const utmParams = getParams();
        
        history.push({
            pathname: "/cadastro-email",
            search: maintainUtm(),
            state: {nome, email, utmParams, obs }
        });
    };

    useEffect(() => {
        const emailValidationError = validateEmail(email);

        setIsButtonDisabled(nome.length < 4 || emailValidationError !== '');
    }, [nome, email]);

    //Verificação dos dados armazenados no state
    useEffect(() => {
        if(location.state) {
            const { nome, email, obs } = location.state;
            setNome(nome);
            setEmail(email);
            const utmParams = getParams();
            setObs(obs);

            if (location.state.emailValidationForm === false) {
                if (nome && email && utmParams && obs) {
                    validaEmail(nome, email, obs);
                }
            }
            
            if (width < 767) {
                const { nome, email, obs } = location.state;
                
                history.push({
                    pathname: "/cadastro-email",
                    search: maintainUtm(),
                    state: {nome, email, utmParams, obs, emailValidationForm: false }
                });
            }
        }
    }, [location.state]);

    useEffect(() => {
        const exit = localStorage.getItem('@exit');
        
        if (exit === 'false') {
            localStorage.clear();
            window.location.reload();
        }
    }, []);

    const renderHeadingText = () => { 
        if (width <= 767) {
            return (
                <>
                    Comece seus 14 dias de teste grátis agora!
                </>
            );
        } else {
            return (
                <>
                    Comece seus 14 dias de<br /> teste grátis no AgroReceita!
                </>
            );
        }
    };

    const renderParagraphText = () => {
        if (width <= 767) {
            return (
                <>
                    Faça seu cadastro e aproveite todas<br /> as funções do plano PRO.
                </>
            );
        } else {
            return (
                <>
                    Preencha os campos solicitados e aproveite para<br /> testar todas as funções do plano PRO.
                </>
            );
        }
    };

    const renderCardInformationText = () => {
        if (width <= 767) {
            return (
                <>
                    Não é necessário cartão de crédito
                </>
            );
        } else {
            return (
                <>
                    Não necessita cartão de crédito
                </>
            );
        }
    };

    const renderCreditCardImage = () => {
        if (width <= 767) {
            return CreditCardMobile;
        } else {
            return CreditCardDesktop;
        }
    };

    const renderFormMobile = () => {
        if (width <= 767) {
            return (
                <S.Form>
                    <S.ContainerSocial>
                        <GoogleLoginButton onSuccess={handleGoogleSuccess} />

                        <S.Social onClick={handleCreatManual}>
                            <img src={Email} alt='Logo do Google' />

                            <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>Continuar com E-mail</TaglineM>
                        </S.Social>
                    </S.ContainerSocial>

                    <a href={`/login${maintainUtm()}`}>
                        <S.ButtonLogin>
                            <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>fazer login</TaglineM>
                        </S.ButtonLogin>
                    </a>

                    <S.ContainerButtonsAndTerms>
                        <Auxiliar color={theme.colors.gray.Cinza_5}>Ao continuar, você concorda com a
                            <label onClick={() => clickPolitica()}> Política de <br />Privacidade </label>
                                e
                            <label onClick={() => clickTermos()}> Termos de Uso.</label>
                        </Auxiliar>
                    </S.ContainerButtonsAndTerms>
                </S.Form>
            )
        } else {
            return (
                <S.Form>
                    <S.ContainerSocial>
                        <GoogleLoginButton onSuccess={handleGoogleSuccess} />
                    </S.ContainerSocial>

                    <S.ContainerDivider>
                        <S.Divider />

                        <TaglineP color={theme.colors.gray.Cinza_2}>ou</TaglineP>

                        <S.Divider />
                    </S.ContainerDivider>

                    <S.ContainerInputs>
                        <InputV3
                            id='nome'
                            type="text"
                            label="nome"
                            floatingLabelWithAsterisk="Nome"
                            placeholder=""
                            value={nome}
                            onChange={handleNomeChange}
                            isDisabled={false}
                            errorInfo={nomeErrorMessage}
                            hasError={!!nomeErrorMessage}
                            onBlur={() => validateNome(nome)}
                            handleClear={() => setNome('')}
                        />

                        <InputV3
                            id='email'
                            type="text"
                            label="e-mail"
                            floatingLabelWithAsterisk="E-mail"
                            placeholder=""
                            value={email}
                            onChange={handleEmailChange}
                            isDisabled={false}
                            errorInfo={emailErrorMessage} 
                            hasError={!!emailErrorMessage} 
                            handleClear={() => setEmail('')}
                        />
                    </S.ContainerInputs>

                    <S.ContainerButtonsAndTerms>
                        <S.ContainerButtons>
                            <S.ContainerRegistration>
                                <a href='/login'>
                                    <BodyP color={theme.colors.blue.Azul_link} fontWeight={700}>Já tenho cadastro</BodyP>
                                </a>
                            </S.ContainerRegistration>

                            <S.FormButton
                                type="submit"
                                disabled={isButtonDisabled}
                                onClick={handleContinuarClick}
                            >
                                {loading ? (
                                    <S.Loading disabled={isButtonDisabled} />
                                ) : (
                                    <>
                                        <TaglineM fontWeight={800}>Continuar</TaglineM>
                                        
                                        <img src={isButtonDisabled ? SetaCinza : SetaBranca} alt='Seta' />
                                    </>
                                )}
                            </S.FormButton>
                        </S.ContainerButtons>

                        <Auxiliar color={theme.colors.gray.Cinza_7}>
                            Ao continuar você concorda com a <br />
                            <label onClick={() => clickPolitica()}>Política de Privacidade </label>
                            e
                            <label onClick={() => clickTermos()}> Termos de Uso.</label>
                        </Auxiliar>
                    </S.ContainerButtonsAndTerms>
                </S.Form>
            )
        }
    }

    return (
        <S.Container>
            <S.Wrapper>
                <S.ContainerDescription>
                    <S.Description>
                        <img src={LogoBranca} alt='Logo AgroReceita Branco' />

                        <H3 color={theme.colors.white.Branco}>{renderHeadingText()}</H3>

                        <BodyG color={theme.colors.gray.Cinza_9}>{renderParagraphText()}</BodyG>

                        <S.NoCreditCard>
                            <img src={renderCreditCardImage()} alt='Ícone de cartão de crédito com risco' />

                            <TaglinePSpan color={theme.colors.gray.Cinza_2}>{renderCardInformationText()}</TaglinePSpan>
                        </S.NoCreditCard>
                    </S.Description>
                </S.ContainerDescription>

                <S.ContainerForm>
                    {renderFormMobile()}
                </S.ContainerForm>
            </S.Wrapper>

            <ModalTermos
                show={showTermos}
                btnOk={true}
                onHide={() => setShowTermos(false)}
            />

            <ModalPoliticas
                show={showPolitica}
                btnOk={true}
                onHide={() => setShowPolitica(false)}
            />
        </S.Container>
    );
};

export default withRouter(NovoCadastro);
